import { Injectable } from '@angular/core';
import { DiagnosisService } from './diagnosis.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpError } from '../../shared/error/http-error';
import { Vehicle } from '../../shared/model/vehicle';
import { FindHttpError } from '../../shared/error/find-http-error';
import { HttpRequestBuilder } from '../../core/http-request-builder';

@Injectable()
export class VehicleService {
  private FIND_VEHICLES_BY_USER = DiagnosisService.DIAGNOSIS_END_POINT + '/getVehiclesByUser';

  find$: Observable<Array<Vehicle>>;
  error$: Observable<HttpError>;

  private findSubject: Subject<Array<Vehicle>>;
  private errorSubject: Subject<HttpError>;

  constructor(private _http: HttpRequestBuilder) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  getVehiclesByUser(userId, diagnosisType) {
    this._http.get(`${this.FIND_VEHICLES_BY_USER}/${userId}/${diagnosisType}`)
      .subscribe(
        (vehicles) => this.findSubject.next(vehicles.json()),
        error => this.errorSubject.next(new FindHttpError(error._body))
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/service/vehicle.service.ts